/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Card, Checkbox, FormControl, FormControlLabel, FormGroup, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Modal, Select, TextField, Typography, } from "@mui/material";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import MDBox from "components/MDBox";
import DeleteIcon from '@mui/icons-material/Delete';
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import ShowProfile from "components/ShowProfileModal/ShowProfileModal";
import CustomText from "components/customtext/customtext";
import DeleteModal from "components/deletemodal/deletemodal";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import getCroppedImg from "layouts/profile/editMyProfile/cropImage";
import MuiPhoneNumber from "material-ui-phone-number";
import ShowSwalWithButtons from "components/SwalAlert/swalPopupWithButtons";
import { useCallback, useEffect, useRef, useState } from "react";
import Cropper from "react-easy-crop";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { appConstants } from "utils/appConstants";
import { addContactData, getContactDetailsByID, updateContactData } from "utils/contactAPI";
import { generateDataList, getScreenRight, showResMsg, validateEmailAddress, validateField, validatePhoneNumber } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import { nonvalidateField } from "utils/generic";
import Auto from "components/AutoComplete/AutoComplete";
import { ContactSupportOutlined, Visibility, VisibilityOff } from "@mui/icons-material";
import { validateABN } from "utils/generic";
import PageTitle from "examples/PageTitle/PageTitle";
import { paymentTermsOptions } from "utils/generic";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import { AllKeysHaveValue } from "utils/generic";
import EmailTemplateModal from "components/EmailModal/EmailTemplateModal";
import { getEmailAndTemplateForContact } from "utils/contactAPI";
import { validateCompanyName } from "utils/generic";
import RouteModal from "components/displayModel/routeModal";

const errMsg = {
  color: `red`,
  fontSize: `11px`,
};
const cropContainer = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: "80px",
};
const style = {
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 450,
  bgcolor: 'background.paper',
  boxShadow: 24,
  // p: 4,
  right: 'auto',
  bottom: 'auto',
  marginRight: '-50%',
};

let routePath = "";
const SCREEN_NAME = "Contact";
let SCREEN_RIGHT;
let myfile;

let paramID = undefined; let paramValue = undefined;
function AddContact() {
  function isValidEmail(email) {
    // Use a regular expression to validate the email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let countryData = useSelector((state) => state.countryState.countryStateMenu.country)
  let stateData = useSelector((state) => state.countryState.countryStateMenu.state)
  const stateListRef = useRef([]);
  const countryListRef = useRef([]);
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const [screenName, setScreenName] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");

  const [openPop, setOpenPop] = useState(false);
  const [deleteDialogeClick, handleDeleteDialogeClick] = useState(false)
  const [addressManually, showAddressManually] = useState(false);
  const [companyNameErr, setCompanyNameErr] = useState(false);
  const [companyErr, setCompanyErr] = useState('');
  const [nameErr, setNameErr] = useState(false);
  const [phoneNoErr, setPhoneNoErr] = useState(false);
  const [phoneNoErrMsg, setPhoneNoErrMsg] = useState('');
  const [emailErr, setEmailErr] = useState(false);
  const [abnNumberErr, setAbnNumberErr] = useState(false);
  const [invoiceReminderErr, setInvoiceReminderErr] = useState(false);
  const [paymentTermsErr, setPaymentTermsErr] = useState(false);
  const [streetAddressErr, setStreetAddressErr] = useState(false);

  const [emailErrMsg, setEmailErrMsg] = useState('');
  const [otherEmailErr, setOtherEmailErr] = useState(false);
  const [otherEmailErrMsg, setOtherEmailErrMsg] = useState('');
  const [addressErr, setAddressErr] = useState(false);
  const [countryErr, setCountryErr] = useState(false);
  const [stateErr, setStateErr] = useState(false);
  const [cityErr, setCityErr] = useState(false);
  const [zipCodeErr, setZipCodeErr] = useState(false);

  const [dynamicAspect, setDynamicAspect] = useState(1 / 1);
  const [file, setFile] = useState();
  const [actualFile, setActualFile] = useState();
  const [fileName, setFileName] = useState("");
  const [showEYEBtn, setShowEYEBtn] = useState(false);
  const [showImageFlag, setShowImageFlag] = useState(false);

  const [showAddress, setShowAddress] = useState(false);

  const { darkMode } = controller;
  const [open, setOpen] = useState(false);
  const [templateValues, setTemplateValues] = useState({
    screenType: "Contact",
    userEmailAddress: '',
    customerEmailAddress: [],
    emailTemplate: ''
  });
  const [values, setValues] = useState({
    bankAccountName: "",
    bankBsbCode: "",
    bankAccountNumber: "",
    otherEmailAddress: [],
    contactType: "Supplier",
    companyName: "",
    companyAccountNo: "",
    name: "",
    phoneNumber: "",
    emailAddress: "",
    websiteName: "",
    abnNumber: "",
    paymentTerms: "7 Days",
    invoiceReminder: "Yes",
    streetAddress: "",
    city: "",
    zipCode: "",
    stateId: "",
    countryId: "",
    address: "",
    state: "",
    country: "",
    contactLogoFileName: "",
    notes: "",
    contactStatus: "Active",
    onlyPhoneNumber: '',
    businessUserID: JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))?.businessUserID,
    token: useState(sessionStorage.getItem("TOKEN")),
  });


  const { barColor, tableBorder } = getColorMappings(sidenavColor);

  useEffect(() => {
    const paramValue = new URLSearchParams(window.location.search).get('new');
    console.log("hjg", paramValue)
    // paramID = new URLSearchParams(window.location.search).get('id');
    switch (paramValue) {
      case "invoice":
        routePath = `/invoices/add`;
        setValues({ ...values, contactType: "Customer" });
        break;
      case "quotation":
        routePath = `/quotations/add`;
        setValues({ ...values, contactType: "Customer" });
        break;
      case "expense":
        console.log("expensestttt", routePath)
        routePath = `/expenses/addExpenses`;
        setValues({ ...values, contactType: "Supplier" })
        break;
      case "rcti":
        routePath = `/rcti/add`;
        setValues({ ...values, contactType: "Supplier" })
        break;
      default:
        routePath = '/contacts';
        break;
    }
    setScreenName(id ? "Edit Contact" : "Add Contact");
    (async () => {
      getRight()
      stateListRef.current = stateData;
      countryListRef.current = countryData;
      setCountry(await generateDataList(countryData, "_id", "countryName"));
      setState(await generateDataList(stateData, "_id", "stateName"));
      if (id !== undefined) {
        values._id = id;
        getContactDetailsByID(values, (data) => {
          let result = data.Result_Output;
          if (result.length > 0) {
            values.streetAddress = result[0].streetAddress;
            values.contactLogoFileName = result[0].contactLogoFileName;
            if (values.contactLogoFileName) {
              setShowEYEBtn(true);
              setFileName(values.contactLogoFileName);
              setFile(appConstants.baseURL + "employee/viewFile?fileName=" + values.contactLogoFileName);
            }
            setValues(result[0])
          }
        }, dispatch)
      }
    }
    )();
  }, [dispatch])

  // ==============For Crop Image Start==============
  const [openCropImageModal, setOpenCropImageModal] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const saveCropedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(file, croppedAreaPixels);
      setFile(croppedImage);
      myfile = await fetch(croppedImage)
        .then((r) => r.blob())
        .then((blobFile) => new File([blobFile], actualFile.name, { type: "image/*" }));
      setActualFile(myfile);
      setFileName(actualFile.name);
      setOpenCropImageModal(false);
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels]);

  const handleCropCancel = async () => {
    setOpenCropImageModal(false)
    setFile();
    setActualFile();
    setFileName('');
    setShowEYEBtn(false)
    setDynamicAspect(1 / 1);
  };

  const saveFile = (e) => {
    try {
      const fileInput = e.target;
      const file = fileInput.files[0];
      if (file) {
        let fileSizeInMB = file.size / (1024 * 1024);
        if (fileSizeInMB > 1) {
          showResMsg(`File can't be blank or more than 1 MB`, 2000, false);
        } else {
          setOpenCropImageModal(true);
          setFile(URL.createObjectURL(file));
          setActualFile(file);
          setFileName(file.name);
          const reader = new FileReader();
          reader.onloadend = () => {
            setShowImageFlag(false);
            setShowEYEBtn(true);
          };
          reader.readAsDataURL(file);
        }
      } else {
        // Handle the case when no file is selected
        setFile(null);
        setActualFile(null);
        setFileName('');
        setShowEYEBtn(false);
      }
      // Reset the file input value to allow re-selection of the same file
      fileInput.value = null;
    } catch (error) {
      console.log("Catch in saveFile=", error);
    }
  };

  const addInput = () => {
    setOtherEmailErrMsg(``);
    setOtherEmailErr(false);

    if (values.otherEmailAddress.length === 0 || values.otherEmailAddress[values.otherEmailAddress.length - 1] !== '') {
      if (values.otherEmailAddress.every(email => isValidEmail(email))) {
        setValues({ ...values, otherEmailAddress: [...values.otherEmailAddress, ''] });
      } else {
        // Show error messages for invalid emails
        const invalidEmailIndices = values.otherEmailAddress.map((email, index) => {
          return !isValidEmail(email) ? index : -1;
        }).filter(index => index !== -1);
        invalidEmailIndices.forEach(index => {
          setOtherEmailErrMsg(`Other Email Address ${index + 1} is invalid.`);
          setOtherEmailErr(true);
        });
      }
    }
  };
  const removeInput = (indexToRemove) => {
    const newEmailAddresses = values.otherEmailAddress.filter((email, index) => index !== indexToRemove);
    setValues({ ...values, otherEmailAddress: newEmailAddresses });
  };


  const handleChange = (name, index) => (event) => {
    const value = event.target.value;
    if (name === 'otherEmailAddress') {
      const listEmailAddress = [...values.otherEmailAddress]
      if (listEmailAddress.includes(value)) {
        alert('Duplicate email address!');
        removeInput(index);
        return;
      }

      const newEmails = values.otherEmailAddress.map((email, i) => (i === index ? value : email));
      setValues({ ...values, otherEmailAddress: newEmails });
    }

    else if (event.target.validity !== undefined && event.target.validity.valid === true) {
      if (name === "abnNumber") {
        let value = event.target.value.replace(/\D/g, ''); // Remove all non-digit characters

        if (name === "abnNumber") {
          value = value.slice(0, 11);

          if (value.length > 2) {
            value = value.slice(0, 2) + ' ' + value.slice(2);
          }
          if (value.length > 6) {
            value = value.slice(0, 6) + ' ' + value.slice(6);
          }
          if (value.length > 10) {
            value = value.slice(0, 10) + ' ' + value.slice(10);
          }
          setValues({ ...values, [name]: value });
        }
      } else
        setValues({ ...values, [name]: event.target.value });
    }
    else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: event.target.value });
    }

  };

  const showAddressDetails = () => {
    // setShowAddress(true)
    let mandateFlag = false;

    if (addressManually) {
      mandateFlag = nonvalidateField(values.address, setAddressErr) || mandateFlag;
      mandateFlag = nonvalidateField(values.city, setCityErr) || mandateFlag;
      mandateFlag = nonvalidateField(values.countryId, setCountryErr) || mandateFlag;
      mandateFlag = nonvalidateField(values.stateId, setStateErr) || mandateFlag;
      mandateFlag = nonvalidateField(values.zipCode, setZipCodeErr) || mandateFlag;
    }
  };


  async function getRight() {
    SCREEN_RIGHT = await getScreenRight(SCREEN_NAME);
  }
  // const setPhoneValues = (phone, country) => {
  //   values.onlyPhoneNumber = phone.toString().slice(country.dialCode.length + 1).trim();
  //   values.phoneNumber = phone;
  //   // values.countryCode = "+" + country.dialCode;
  // };


  const deleteDocumentLogo = async () => {
    setActualFile(null);
    setShowEYEBtn(false);
    setFileName("");

  };


  const setPhoneValues = (phone, country) => {
    const dialCode = country.dialCode;

    // Remove country code safely
    const onlyNumber = phone.replace(`+${dialCode}`, "").trim();

    setValues(prev => ({
      ...prev,
      phoneNumber: phone,
      onlyPhoneNumber: onlyNumber,
      countryCode: `+${dialCode}`
    }));

    // Clear error once user starts typing
    if (onlyNumber.length > 0) {
      setPhoneNoErr(false);

    }
  };



  const handleStreetOnChange = (e) => {

    if (e.target.value === "") {
      setValues((prevValues) => ({
        ...prevValues,
        city: "",
        countryId: "",
        zipCode: "",
        stateId: "",
        streetAddress: ""
      }));
    } else {
      setValues((prevValues) => ({
        ...prevValues,
        streetAddress: e.target.value,
      }));
      setStreetAddressErr(false);

    }
  };
  const handleStreetAddress = (place, e) => {
    console.log("eee", place, e)
    const countryList = countryListRef.current;
    const stateList = stateListRef.current;
    const addressComponents = place.address_components || [];
    values.streetAddress = place.formatted_address;

    const data = addressComponents.reduce((acc, item) => {
      if (
        item.types &&
        Array.isArray(item.types) &&
        item.types.includes("postal_code") &&
        item.long_name
      ) {
        acc.zipCode = item.long_name;
      } else if (
        item.types &&
        Array.isArray(item.types) &&
        item.types.includes("locality") &&
        item.long_name
      ) {
        acc.city = item.long_name;
      } else if (
        item.types &&
        Array.isArray(item.types) &&
        item.types.includes("country") &&
        item.long_name
      ) {
        acc.countryName = item.long_name; // Store country name temporarily
      } else if (
        item.types &&
        Array.isArray(item.types) &&
        item.types.includes("administrative_area_level_1") &&
        item.long_name
      ) {
        acc.stateName = item.long_name; // Store state name temporarily
      }
      return acc;
    }, {});

    const isEmptyAddress = place.name === "";

    // Update specific fields in the values object
    if (!isEmptyAddress) {
      if (data.city) {
        values.city = data.city;
      }
      if (data.streetAddress) {
        if (data.streetNumber !== undefined) {
          values.streetAddress = (data.streetNumber + " " + data.streetAddress);
        } else {
          values.streetAddress = data.streetAddress;
        }
      }
      if (data.zipCode) {
        values.zipCode = data.zipCode;
      }
      if (data.countryName && Array.isArray(countryList)) {
        const country = countryList.find((item) => item.countryName === data.countryName);
        values.countryId = country ? country._id : "";
      }
      if (data.stateName && Array.isArray(stateList)) {
        const state = stateList.find((item) => item.stateName === data.stateName);
        values.stateId = state ? state._id : "";
      }
    } else {
      // Clear the values if place name is empty
      values.city = "";
      values.zipCode = "";
      values.countryId = "";
      values.stateId = "";
    }
    // Create a new object to trigger state update
    setValues((prevValues) => ({
      ...prevValues,
      zipCode: values.zipCode,
      city: values.city,
      countryId: values.countryId,
      stateId: values.stateId,
      streetAddress: values.streetAddress,

    }));
  };

  const clearAllErrorMsg = () => {
    setNameErr("");
    // setAbnNumberErr("");
    setInvoiceReminderErr("");
    setCompanyNameErr("");
    setEmailErrMsg("");
    setEmailErr(false);
    setPhoneNoErr(false);
    setOtherEmailErr(false);
    setOtherEmailErrMsg("");
    setPaymentTermsErr(false);
    setAddressErr(false);
    setCityErr(false);
    setZipCodeErr(false);
    setCountryErr(false);
    setStateErr(false);
  }

  const combineAddress = () => {
    const { address, city, stateId, countryId, zipCode } = values;
    console.log("combineAddress-values", values)
    stateListRef.current = stateData;
    countryListRef.current = countryData;

    const stateName = stateData.find(state => state._id === stateId)?.stateName || '';
    const countryName = countryData.find(country => country._id === countryId)?.countryName || '';
    console.log("address", `${address}`)
    const combined = `${address}, ${city}, ${stateName}, ${countryName}, ${zipCode}`
      .replace(/, ,/g, ',')
      .replace(/, $/, '')
      .trim();
    // console.log("combine", combined)
    if (combined, stateName, countryName) {
      values.streetAddress = combined
      values.state = stateName
      values.country = countryName
    }
    // setValues({
    //   ...values, streetAddress: combined, state: stateName,
    //   country: countryName,
    // });
    // setValues(prevValues => ({
    //   ...prevValues,
    //   state: stateName,
    //   country: countryName,
    //   streetAddress: combined,
    // }));
  };


  const handleSendContact = async () => {
    console.log("values before", values)

    clearAllErrorMsg();
    if (addressManually === true) {

      // values.streetAddress = values.address
      console.log("dcocb")
      combineAddress();
    }

    let mandateFlag = false;
    if (values.abnNumber) {
      if (!validateABN(values.abnNumber)) {
        showResMsg(genericMessage.invalidABN, 2000, false);
        mandateFlag = true;
      }
    }

    if (values.otherEmailAddress.length > 0) {

      if (values.otherEmailAddress[0] === '') {
        values.otherEmailAddress = []; // Clear other emails
      }
      else {
        const invalidEmailIndices = values.otherEmailAddress.map((email, index) => {
          return !isValidEmail(email) ? index : -1;
        }).filter(index => index !== -1);

        if (invalidEmailIndices.length > 0) {
          // Show error messages for invalid emails
          invalidEmailIndices.forEach(index => {
            setOtherEmailErrMsg(`Other Email Address ${index + 1} is invalid.`)
            setOtherEmailErr(true);
            mandateFlag = true;
            return;
            // You can also update the state to show error messages next to the input fields
          });
        }
        else if (values.otherEmailAddress.some(email => email === values.emailAddress)) {
          // Show error message for matching primary email
          setOtherEmailErrMsg(`Other Email Address cannot be the same as primary email.`);
          setOtherEmailErr(true);
          mandateFlag = true;
          return;
        }
      }
    }

    if (values.contactType === "Customer") {
      mandateFlag = validateField(values.invoiceReminder, setInvoiceReminderErr) || mandateFlag;
      mandateFlag = validateField(values.paymentTerms, setPaymentTermsErr) || mandateFlag;
    }
    console.log("companyName", values.companyName)

    mandateFlag = validateField(values.name, setNameErr) || mandateFlag;

    // if (values.companyName !== undefined) {
    //   const companyName = values.companyName.toString().trim();

    //   // Must contain at least one letter, and can include letters, numbers, and dots
    //   const regex = /^(?=.*[a-zA-Z ])[a-zA-Z0-9. ]+$/;

    //   if (!regex.test(companyName)) {
    //     setCompanyNameErr(true);
    //     setCompanyErr(
    //       "Company Name must contain at least one letter and can include numbers and '.'"
    //     );
    //     mandateFlag = true;
    //   } else {
    //     setCompanyNameErr(false);
    //     setCompanyErr("");
    //     mandateFlag = false;
    //   }
    // } else {
    //   setCompanyNameErr(true);
    //   setCompanyErr("Company Name can't be blank");
    //   mandateFlag = true;
    // }

    mandateFlag = validateField(values.companyName, setCompanyNameErr) || mandateFlag;
    // mandateFlag = validateField(values.abnNumber, setAbnNumberErr) || mandateFlag;
    if (addressManually === true) {
      // mandateFlag = validateField(values.addressManualy, setStreetAddressErr) || mandateFlag;
      mandateFlag = validateField(values.address, setAddressErr) || mandateFlag;
      mandateFlag = validateField(values.countryId, setCountryErr) || mandateFlag;
      mandateFlag = validateField(values.stateId, setStateErr) || mandateFlag;
      mandateFlag = validateField(values.city, setCityErr) || mandateFlag;
      mandateFlag = validateField(values.zipCode, setZipCodeErr) || mandateFlag;

    }
    else {
      mandateFlag = validateField(values.streetAddress, setStreetAddressErr) || mandateFlag;
    }


    // mandateFlag = validateField(values.companyAccountNo, setCompanyAccountNoErr) || mandateFlag;

    mandateFlag = validateEmailAddress(values.emailAddress, setEmailErr, setEmailErrMsg) || mandateFlag;
    if (values.onlyPhoneNumber === '' || values.onlyPhoneNumber === undefined) {
      values.onlyPhoneNumber = values.phoneNumber;
    }
    mandateFlag = validatePhoneNumber(values.onlyPhoneNumber, setPhoneNoErr, setPhoneNoErrMsg) || mandateFlag;

    if (mandateFlag) {
      return;
    }
    const apiFunction = (id === undefined) ? addContactData : updateContactData;
    apiFunction(values, (data) => {

      if (data.Result_Status) {
        showResMsg(data.Result_Status ? id === undefined ? genericMessage.added : data.Result_Message : data.Result_Message, 2000, data.Result_Status, navigate, `${routePath}?contact=${data.Result_Output?._id}`);
      } else {
        showResMsg(data.Result_Message, 2000, data.Result_Status);
      }
    }, dispatch);
  }


  const handleSaveContact = async () => {
    clearAllErrorMsg();
    if (addressManually === true) {
      // values.streetAddress = values.address
      console.log("dcocb")
      combineAddress();
    }

    let mandateFlag = false;
    if (values.abnNumber) {
      if (!validateABN(values.abnNumber)) {
        showResMsg(genericMessage.invalidABN, 2000, false);
        mandateFlag = true;
      }
    }

    if (values.otherEmailAddress.length > 0) {

      if (values.otherEmailAddress[0] === '') {
        values.otherEmailAddress = []; // Clear other emails
      }
      else {
        const invalidEmailIndices = values.otherEmailAddress.map((email, index) => {
          return !isValidEmail(email) ? index : -1;
        }).filter(index => index !== -1);

        if (invalidEmailIndices.length > 0) {
          // Show error messages for invalid emails
          invalidEmailIndices.forEach(index => {
            setOtherEmailErrMsg(`Other Email Address ${index + 1} is invalid.`)
            setOtherEmailErr(true);
            mandateFlag = true;
            return;
            // You can also update the state to show error messages next to the input fields
          });
        }
        else if (values.otherEmailAddress.some(email => email === values.emailAddress)) {
          // Show error message for matching primary email
          setOtherEmailErrMsg(`Other Email Address cannot be the same as primary email.`);
          setOtherEmailErr(true);
          mandateFlag = true;
          return;
        }
      }
    }

    if (values.contactType === "Customer") {
      mandateFlag = validateField(values.invoiceReminder, setInvoiceReminderErr) || mandateFlag;
      mandateFlag = validateField(values.paymentTerms, setPaymentTermsErr) || mandateFlag;
    }
    mandateFlag = validateField(values.name, setNameErr) || mandateFlag;
    console.log("companyName", values.companyName)
    mandateFlag = validateField(values.companyName, setCompanyNameErr) || mandateFlag;
    // if (values.companyName !== undefined) {
    //   const companyName = values.companyName.toString().trim();

    //   // Must contain at least one letter, and can include letters, numbers, and dots
    //   const regex = /^(?=.*[a-zA-Z ])[a-zA-Z0-9. ]+$/;

    //   if (!regex.test(companyName)) {
    //     setCompanyNameErr(true);
    //     setCompanyErr(
    //       "Company Name must contain at least one letter and can include numbers and '.'"
    //     );
    //     mandateFlag = true;
    //   } else {
    //     setCompanyNameErr(false);
    //     setCompanyErr("");
    //     mandateFlag = false;
    //   }
    // } else {
    //   setCompanyNameErr(true);
    //   setCompanyErr("Company Name can't be blank");
    //   mandateFlag = true;
    // }

    console.log("mandateFlag", mandateFlag)
    // mandateFlag = validateField(values.abnNumber, setAbnNumberErr) || mandateFlag;
    if (addressManually === true) {
      // mandateFlag = validateField(values.addressManualy, setStreetAddressErr) || mandateFlag;
      mandateFlag = validateField(values.address, setAddressErr) || mandateFlag;
      mandateFlag = validateField(values.countryId, setCountryErr) || mandateFlag;
      mandateFlag = validateField(values.stateId, setStateErr) || mandateFlag;
      mandateFlag = validateField(values.city, setCityErr) || mandateFlag;
      mandateFlag = validateField(values.zipCode, setZipCodeErr) || mandateFlag;
    }
    else {
      console.log("streetAddress", values.streetAddress)
      mandateFlag = validateField(values.streetAddress, setStreetAddressErr) || mandateFlag;
    }
    // mandateFlag = validateField(values.companyAccountNo, setCompanyAccountNoErr) || mandateFlag;
    mandateFlag = validateEmailAddress(values.emailAddress, setEmailErr, setEmailErrMsg) || mandateFlag;

    if (values.onlyPhoneNumber === '' || values.onlyPhoneNumber === undefined) {
      values.onlyPhoneNumber = values.phoneNumber;
    }

    mandateFlag = validatePhoneNumber(values.onlyPhoneNumber, setPhoneNoErr, setPhoneNoErrMsg) || mandateFlag;

    if (mandateFlag) {
      return;
    }

    const formData = new FormData();
    const arrayOfObjects = Object.entries(values).map(([key, value]) => ({ key, value }));
    for (const val of arrayOfObjects) {
      if (val.value) {
        formData.append(val.key, val.value);
      }
    }
    if (actualFile && fileName !== undefined && actualFile && fileName !== "") {
      formData.append('file', actualFile);
      formData.append("fileName", fileName);
    }
    const apiFunction = (id === undefined) ? addContactData : updateContactData;
    apiFunction(formData, (data) => {

      if (data.Result_Status) {
        const paramValue = new URLSearchParams(window.location.search).get('new');
        if (paramValue == "expense") {
          console.log("Result_Output", data.Result_Output)
          showResMsg(data.Result_Status ? id === undefined ? genericMessage.added : genericMessage.updated : data.Result_Message, 2000, data.Result_Status, navigate, `${routePath}?contact=${data.Result_Output?.id}`)
          return;
        }
        if (values.contactType == "Supplier") {

          showResMsg(data.Result_Status ? id === undefined ? genericMessage.added : genericMessage.updated : data.Result_Message, 2000, data.Result_Status)
          if (values.contactVerifiedStatus !== "Verified") {
            setOpenPop(true)
            return;
          } else {
            navigate('/contacts')
          }

        } else {
          showResMsg(data.Result_Status ? id === undefined ? genericMessage.added : genericMessage.updated : data.Result_Message, 2000, data.Result_Status, navigate, `${routePath}?contact=${data.Result_Output?._id}`)
        }

        // navigate('/contacts')


      } else {
        showResMsg(data.Result_Message, 2000, data.Result_Status);
      }
    }, dispatch);
  }

  const handleRoute = () => {
    // const contactFromUrl = new URLSearchParams(window.location.search).get('contact');
    // if (contactFromUrl) {
    //   navigate(`/contacts/editContact/${contactFromUrl}`);
    // }
    navigate(`/contacts`);
    setOpenPop(false)
  }

  const handleRouteCancel = () => {
    setOpenPop(false)
  }

  const handleCancel = (index) => {
    ShowSwalWithButtons(
      'Are you sure?',

      `Would you like to exit from this ${id
        ? "Edit Contact"
        : "Add New Contact"
      }?`,
      'warning',
      darkMode,
      () => {

        const paramValue = new URLSearchParams(window.location.search).get('new');

        console.log("paramValue", paramValue)

        switch (paramValue) {
          case "invoice":
            routePath = `/invoices/add`;
            setValues({ ...values, contactType: "Customer" });
            break;
          case "quotation":
            routePath = `/quotations/add`;
            setValues({ ...values, contactType: "Customer" });
            break;
          case "expense":
            routePath = `/expenses/addExpenses`;
            break;
          case "rcti":
            routePath = `/rcti/add`;
            setValues({ ...values, contactType: "Supplier" })
            break;
          default:
            routePath = '/contacts';
            break;
        }
        console.log("routePath", routePath)
        navigate(routePath);

      }
    );

  };

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setOpen(false)
  };

  const handleSend = (templateData) => {
    let payload = {
      userEmailAddress: templateData.userEmailAddress,
      customerEmailAddress: [...templateData.customerEmailAddress],
      emailTemplate: { ...templateData.emailTemplate },
      sendMeCopy: templateData.sendMeCopy,
    };
    values.sendEmailFlag = true;
    values.templateValues = payload;
    console.log("PlayLoad", values.templateValues)

    handleSendContact();
    setOpen(false)
  }

  const handleSendEmail = async () => {
    if (AllKeysHaveValue(templateValues)) {
      setOpen(true);
    } else {
      await getEmailAndTemplateForContact({ screenType: templateValues.screenType, contactID: id, userID: sessionStorage.getItem("USER_ID").replaceAll('"', "") }, (data) => {
        if (data.Result_Status) {
          setTemplateValues(data.Result_Output);
          setOpen(true);
        } else {
          showResMsg(data.Result_Message, 2000, false);
          setOpen(false);
        }
      }, dispatch);
    }
  }


  const handleAddressCheckBox = (event) => {
    const checked = event.target.checked;
    if (checked) {
      showAddressManually(true);
      setShowAddress(true);
      // setValues({
      //   ...values, address: '',
      //   streetAddress: "",
      //   city: "",
      //   zipCode: "",
      //   stateId: "",
      //   countryId: "",
      // })

    } else {
      showAddressManually(false);
      setShowAddress(false);
      setValues({
        ...values, address: ''
      })
    }
  };


  useEffect(() => {
    var element = document.getElementsByTagName('fieldset');
    let labelShrink = document.getElementsByClassName("MuiInputLabel-outlined");
    var disabledval = document.querySelectorAll('.Mui-disabled');
    var dropicons = document.querySelectorAll('.MuiInputBase-root');
    for (let i = 0; i < element.length; i++) {

      element[i].style.borderColor = darkMode ? "white" : tableBorder;
    }

    for (let i = 0; i < labelShrink.length; i++) {
      labelShrink[i].style.color = darkMode ? "white" : tableBorder;;
    }

    for (let i = 0; i < disabledval.length; i++) {
      var usevalue = disabledval[i].getElementsByTagName('input');

      if (usevalue.length > 0) {
        if (darkMode) {
          usevalue[0].style.setProperty("-webkit-text-fill-color", "white", "important");

        } else {
          usevalue[0].style.removeProperty("-webkit-text-fill-color");
        }
      }
    }

    for (let i = 0; i < dropicons.length; i++) {
      var svgicon = dropicons[i].getElementsByTagName('svg');
      if (svgicon.length > 0) {
        if (darkMode) {
          svgicon[0].setAttribute("style", "fill: white !important;");
        } else {
          svgicon[0].setAttribute("style", "fill:");
        }
      }
    }
  }, [showAddress])




  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: "20px" }}>
        <Card sx={{ boxShadow: "none" }}>
          <PageTitle screenName={screenName} />
          <MDBox mt={3} mb={3}>

            <Grid container spacing={1} style={{ display: "flex", justifyContent: "center" }}>
              <Grid item lg={12} xs={12}>

                <MDBox>
                  <Grid container px={2} py={2} spacing={3}>
                    <Grid item lg={12} mb={-1} mt={-1}>
                      <CustomText type="b" color="white">
                        Contact Details
                      </CustomText>
                    </Grid>

                    <Grid item lg={4} xs={12}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Contact Type</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          style={{ height: "35.11px" }}
                          label="Contact Type"
                          onChange={handleChange("contactType")}
                          value={values.contactType}
                        >
                          <MenuItem value="Supplier">Supplier</MenuItem>
                          <MenuItem value="Customer">Customer</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item lg={4} xs={12}>
                      <TextField
                        type="text"
                        label="Company Name"
                        variant="outlined"
                        fullWidth
                        inputProps={{
                          maxLength: 100,
                          autoComplete: "companyName",
                          className: "custom-fieldtext",
                          pattern: "^[a-zA-Z ]+$"
                        }}
                        name="organisation"
                        value={values.companyName}
                        placeholder="Company Name"
                        onChange={handleChange("companyName")}
                        autoFocus={true}
                      />
                      {/* {companyNameErr ? <span style={errMsg}> {companyErr}</span> : ""} */}
                      {companyNameErr ? <p style={errMsg}> Company Name can't be blank</p> : ""}
                    </Grid>
                    <Grid item lg={4} xs={12}>
                      <FormControl fullWidth>
                        <InputLabel id="Status-select-label">Contact Status</InputLabel>
                        <Select
                          labelId="Status-select-label"
                          style={{ height: "35.11px" }}
                          disabled={id === undefined}
                          label="Contact Status"
                          onChange={handleChange("contactStatus")}
                          value={values.contactStatus}
                        >
                          <MenuItem value="Active">Active</MenuItem>
                          <MenuItem value="Inactive">Inactive</MenuItem>
                        </Select>

                      </FormControl>
                    </Grid>
                    {/* <Grid item lg={4} xs={12}>
                    <TextField
                      type="text"
                      label="Company Account No."
                      variant="outlined"
                      fullWidth
                      name="companyAccountNo"
                      inputProps={{
                        maxLength: 15,
                        pattern: "^[a-zA-Z0-9 ]+$",
                        autoComplete: "account-number"
                      }}
                      value={values.companyAccountNo}
                      onChange={handleChange("companyAccountNo")}
                    />
                    {companyAccountNoErr ? <p style={errMsg}> Company Account No. can't be blank</p> : ""}
                  </Grid> */}

                    <Grid item lg={12} mb={-2} mt={-1}>
                      <CustomText type="b" color="white">
                        Primary Person Details
                      </CustomText>
                    </Grid>
                    <Grid item lg={4} xs={12}>
                      <TextField
                        type="text"
                        label="Full Name"
                        variant="outlined"
                        placeholder="Full Name"
                        fullWidth
                        name="name"
                        disabled={id !== undefined}
                        inputProps={{
                          maxLength: 50,
                          className: "custom-fieldtext",
                          autoComplete: "name",
                          pattern: "^[a-zA-Z ]+$"
                        }}
                        value={values.name}
                        onChange={handleChange("name")}
                      />
                      {nameErr ? <p style={errMsg}> Name can't be blank</p> : ""}
                    </Grid>

                    <Grid item lg={4} xs={12}>
                      <MuiPhoneNumber
                        onlyCountries={["in", "au"]}
                        defaultCountry={"au"}
                        type="text"
                        label="Mobile Number"
                        variant="outlined"
                        fullWidth
                        inputProps={{
                          className: "custom-fieldtext",
                        }}
                        value={values.phoneNumber}
                        onChange={(phone, country) => setPhoneValues(phone, country)}
                      />
                      {phoneNoErr ? <span style={errMsg}> {phoneNoErrMsg}</span> : ""}

                    </Grid>

                    <Grid item lg={4} xs={12}>
                      <TextField
                        type="text"
                        label="Email Address"
                        placeholder="Email Address"
                        variant="outlined"
                        fullWidth
                        disabled={id !== undefined}
                        inputProps={{
                          maxLength: 35,
                          autoComplete: "email",
                          className: "custom-fieldtext",

                        }}
                        value={values.emailAddress}
                        onChange={handleChange("emailAddress")}
                      />
                      {emailErr ? <p style={errMsg}>{emailErrMsg}</p> : ""}
                    </Grid>


                    <Grid item lg={4} xs={12}>
                      <TextField
                        type="text"
                        label="ABN Number"
                        placeholder="Optional"
                        variant="outlined"
                        fullWidth
                        inputProps={{
                          maxLength: 15,
                          pattern: "^[a-zA-Z0-9 ]+$",
                          autoComplete: "abnNumber", className: "custom-fieldtext",
                        }}
                        value={values.abnNumber}
                        onChange={handleChange("abnNumber")}
                      />
                      <MDTypography
                        variant="button"
                        color="warning"
                        fontWeight="medium"
                        textGradient
                        style={{ borderBottom: "2px solid #FFC107" }}
                      >
                        <a href="https://abr.business.gov.au/" target="_blank" rel="noreferrer">
                          Check ABN Number
                        </a>
                      </MDTypography>
                      {abnNumberErr ? <p style={errMsg}> ABN Number can't be blank</p> : ""}
                    </Grid>
                    <Grid item lg={4} xs={12}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Invoice Reminder</InputLabel>
                        <Select

                          labelId="demo-simple-select-label"
                          style={{ height: "35.11px" }}
                          disabled={values.contactType === "Supplier"}
                          label="Invoice Reminder"
                          onChange={handleChange("invoiceReminder")}
                          value={values.invoiceReminder}
                        >
                          <MenuItem value="Yes">Yes</MenuItem>
                          <MenuItem value="No">No</MenuItem>
                        </Select>
                        {invoiceReminderErr ? <p style={errMsg}>Please select Invoice Reminder</p> : ""}
                      </FormControl>
                    </Grid>
                    <Grid item lg={12} xs={12}>
                      <FormControl fullWidth>
                        <InputLabel id="paymentTerms-label" shrink>Payment Terms</InputLabel>
                        <Select
                          labelId="paymentTerms-label"
                          label="Payment Terms"
                          // disabled={values.contactType === "Supplier"}
                          style={{ height: "35.11px", minHeight: "30px" }}
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 200,
                              },
                            },
                          }}
                          onChange={handleChange("paymentTerms")}
                          value={values.paymentTerms}
                          displayEmpty
                        >
                          <MenuItem disabled value="">Select Payment Term</MenuItem>
                          {paymentTermsOptions.map((option, index) => (
                            <MenuItem key={index} value={option}>{option}</MenuItem>
                          ))}
                        </Select>
                        {paymentTermsErr ? <p style={errMsg}>Please select a Payment Terms</p> : ""}
                      </FormControl>


                    </Grid>
                    <Grid item lg={12} mb={-2} mt={-1}>
                      <CustomText type="b" color="white">
                        Address Details
                      </CustomText>
                    </Grid>


                    <Grid item lg={12} xs={12}>

                      <Grid item lg={12} xs={12}>
                        <Auto
                          onChange={handleStreetOnChange}
                          onPlaceSelected={(place, e) => handleStreetAddress(place, e)}
                          defaultValue={values.streetAddress}
                        // disabled={addressManually === false ? false : true}
                        />
                        {streetAddressErr && !addressManually && (
                          <p style={errMsg}>Street Address can't be blank</p>
                        )}
                      </Grid>



                      <Grid lg={3} xs={4}>
                        <FormGroup>
                          <FormControlLabel
                            className="checkedin"
                            control={
                              <Checkbox
                                onChange={handleAddressCheckBox}
                                onClick={showAddressDetails}
                              />
                            }
                            label="Enter Address Manually"
                          />
                        </FormGroup>
                      </Grid>


                    </Grid>
                    {showAddress && (
                      <>
                        {/* Address Field */}
                        <Grid item lg={8} xs={12}>
                          <TextField
                            type="text"
                            label="Address"
                            variant="outlined"
                            placeholder="Enter address"
                            fullWidth
                            autoFocus={true}
                            disabled={!addressManually} // Disable if addressManually is false
                            inputProps={{
                              maxLength: 30,
                              pattern: "^[a-zA-Z0-9!@#$%^&*()_+=-{};:'<>,./?]+$",
                              className: "custom-fieldtext",
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            value={values.address}
                            onChange={handleChange("address")}
                          />
                          {addressErr && <p style={errMsg}>Address can't be blank</p>}
                        </Grid>

                        {/* Country Select */}
                        <Grid item xs={12} lg={4}>
                          <FormControl fullWidth>
                            <InputLabel id="country-label">Country</InputLabel>
                            <Select
                              labelId="country-label"
                              id="country-select"
                              disabled={!addressManually} // Disable if addressManually is false
                              style={{ height: "35.11px" }}
                              label="Country"
                              onChange={handleChange("countryId")}
                              value={values.countryId}
                            >
                              {country}
                            </Select>
                            {countryErr && <p style={errMsg}>Country can't be blank</p>}
                          </FormControl>
                        </Grid>

                        {/* State Select */}
                        <Grid item xs={12} lg={4}>
                          <FormControl fullWidth>
                            <InputLabel id="state-label">State</InputLabel>
                            <Select
                              labelId="state-label"
                              disabled={!addressManually} // Disable if addressManually is false
                              id="state-select"
                              style={{ height: "35.11px" }}
                              label="State"
                              onChange={handleChange("stateId")}
                              value={values.stateId}
                            >
                              {state}
                            </Select>
                            {stateErr && <p style={errMsg}>State can't be blank</p>}
                          </FormControl>
                        </Grid>

                        {/* City Field */}
                        <Grid item xs={12} lg={4}>
                          <TextField
                            type="text"
                            label="City"
                            variant="outlined"
                            fullWidth
                            disabled={!addressManually} // Disable if addressManually is false
                            inputProps={{
                              pattern: "^[a-zA-Z0-9!@#$%^&*()_+=-{};:'<>,./?]+$",
                              maxLength: 30,
                              className: "custom-fieldtext",
                            }}
                            InputLabelProps={{ shrink: values.city ? true : false }}
                            value={values.city}
                            onChange={handleChange("city")}
                          />
                          {cityErr && <p style={errMsg}>City can't be blank</p>}
                        </Grid>

                        {/* Zip Code Field */}
                        <Grid item xs={12} lg={4}>
                          <TextField
                            type="text"
                            label="Zip Code"
                            variant="outlined"
                            fullWidth
                            disabled={!addressManually} // Disable if addressManually is false
                            inputProps={{
                              pattern: "^[a-zA-Z0-9 ]+$",
                              maxLength: 4,
                              className: "custom-fieldtext",
                            }}
                            InputLabelProps={{ shrink: values.zipCode ? true : false }}
                            value={values.zipCode}
                            onChange={handleChange("zipCode")}
                          />
                          {zipCodeErr && <p style={errMsg}>Zip Code can't be blank</p>}
                        </Grid>
                      </>
                    )}
                    <Grid item lg={12} mb={-2} mt={-1}>
                      <CustomText type="b" color="white">
                        Financial Details (Optional)
                      </CustomText>
                    </Grid>
                    <Grid item lg={4} xs={12}>
                      <TextField
                        type="text"
                        label="Bank Account Name"
                        variant="outlined"
                        placeholder="Bank Account Name"
                        fullWidth
                        name="Bank Account Name"
                        // disabled={id !== undefined}
                        inputProps={{
                          maxLength: 30,
                          className: "custom-fieldtext",
                          autoComplete: "name"
                        }}
                        value={values.bankAccountName}
                        onChange={handleChange("bankAccountName")}
                      />
                      {/* {nameErr ? <p style={errMsg}> Bank Account Name can't be blank</p> : ""} */}
                    </Grid>

                    <Grid item lg={4} xs={12}>
                      <TextField
                        type="text"
                        label="Bank BSB Code"
                        variant="outlined"
                        placeholder="Bank BSB Code"
                        fullWidth
                        name="Bank BSB Code"
                        // disabled={id !== undefined}
                        inputProps={{
                          maxLength: 30,
                          className: "custom-fieldtext",
                          autoComplete: "name",
                          pattern: "^[0-9]+$"
                        }}
                        value={values.bankBsbCode}
                        onChange={handleChange("bankBsbCode")}
                      />
                      {/* {nameErr ? <p style={errMsg}> Bank Account Name can't be blank</p> : ""} */}
                    </Grid>

                    <Grid item lg={4} xs={12}>
                      <TextField
                        type="text"
                        label="Bank Account Number"
                        variant="outlined"
                        placeholder="Bank Account Number"
                        fullWidth
                        name="Bank Account Number"
                        // disabled={id !== undefined}
                        inputProps={{
                          maxLength: 30,
                          className: "custom-fieldtext",
                          autoComplete: "name",
                          pattern: "^[0-9]+$"
                        }}
                        value={values.bankAccountNumber}
                        onChange={handleChange("bankAccountNumber")}
                      />
                      {/* {nameErr ? <p style={errMsg}> Bank Account Name can't be blank</p> : ""} */}
                    </Grid>
                    {/* logo */}
                    <Grid item lg={12} mb={-2} mt={-1}>
                      <CustomText type="b" color="white">
                        Upload Logo
                      </CustomText>
                    </Grid>
                    <Grid item xs={12} lg={3.7}>
                      <label htmlFor="fileInput">
                        <TextField
                          type="text"
                          label="Upload Logo"
                          variant="outlined"
                          fullWidth
                          value={fileName}
                          InputProps={{
                            readOnly: true,
                            className: "uploadfile",
                            endAdornment: (
                              <InputAdornment position="end">
                                <label className="ress" htmlFor="fileInput">
                                  <Button

                                    component="span"
                                    size="small"
                                    allign="right"
                                    style={{ fontSize: "14px", marginTop: "4px", color: `${tableBorder}`, marginLeft: "-19px", textDecoration: "2px solid underline" }}
                                  >
                                    Choose File
                                  </Button>


                                </label>
                                {/* {showEYEBtn ?
                              <IconButton style={{ marginLeft: "2px" }}>
                          <Visibility fontSize="medium" color="info" onClick={() => { setShowImageFlag(true); }} />
                           </IconButton>
                            :
                              <IconButton style={{ marginLeft: "2px" }}>
                            <VisibilityOff fontSize="medium" color="grey" />
                              </IconButton>} */}

                                <IconButton style={{ marginLeft: "2px" }}>
                                  {showEYEBtn ?
                                    <Visibility fontSize="medium" color="info" onClick={() => { setShowImageFlag(true); }} />
                                    :
                                    <VisibilityOff fontSize="medium" color="grey" />
                                  }
                                </IconButton>

                                <IconButton onClick={deleteDocumentLogo} style={{ marginRight: '-2px' }} >
                                  <DeleteIcon fontSize="small" color="error" />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                        <input
                          type="file"
                          accept="image/*"
                          id="fileInput"
                          style={{ display: "none" }}
                          onChange={saveFile}
                        />
                      </label>
                    </Grid>
                    {/* <Grid item xs={0.3} pl={0}>
                      {showEYEBtn ?
                        <IconButton style={{ marginLeft: "-25px" }}>
                          <Visibility fontSize="large" color="info" onClick={() => { setShowImageFlag(true); }} />
                        </IconButton>
                        :
                        <IconButton style={{ marginLeft: "-25px" }}>
                          <VisibilityOff fontSize="large" color="grey" />
                        </IconButton>}

                    </Grid> */}
                    <Grid item xs={12} lg={12}>
                      <TextField
                        type="text"
                        label="Notes (Optional)"
                        variant="outlined"
                        fullWidth
                        inputProps={{
                          className: "custom-fieldtextabc",
                          maxLength: 5000,

                        }}

                        multiline
                        rows={4}
                        value={values.notes}
                        onChange={handleChange("notes")}

                      />
                    </Grid>



                    <Grid item lg={12} mb={-2} mt={-1}>
                      <CustomText type="b" color="white">Other Email Address</CustomText>
                      <IconButton onClick={addInput}>
                        <AddCircleIcon />
                      </IconButton>
                      {otherEmailErr ? <p style={errMsg}>{otherEmailErrMsg}</p> : ""}
                    </Grid>

                    {/* othre emails fields */}
                    {values.otherEmailAddress.length > 0
                      && values.otherEmailAddress.map((input, index) => (
                        <>
                          <Grid item lg={3} mb={-2} mt={-1} display={"flex"} key={index}>
                            <TextField
                              fullWidth
                              type="text"
                              margin="normal"
                              variant="outlined"
                              placeholder="Optional"
                              autoComplete="new-password" //it will off the autoComplete.
                              name="otherEmailAddress"
                              inputProps={{ maxLength: 30, pattern: "^[a-zA-Z0-9 ]+$", className: "custom-fieldtext" }}
                              data-index={index} // Add data-index attribute to identify the index                          
                              label={`Other Email Address ${index + 1}`}
                              value={values.otherEmailAddress[index]}
                              onChange={handleChange('otherEmailAddress', index)} // Pass index as an argument
                            />
                            {index >= 0 && ( // Show remove icon for all inputs except the first one
                              <IconButton onClick={() => removeInput(index)}>
                                <HighlightOffIcon />
                              </IconButton>
                            )}
                          </Grid>

                        </>
                      ))
                    }

                  </Grid>
                </MDBox>


                <Grid
                  container
                  // mt={2}
                  pb={3}
                  columnSpacing={4}
                  alignItems="center"
                  display="flex"
                  justifyContent="center"
                >

                  <Grid item xs={12} md={4} spacing={2} lg={1.8}>
                    {/* <Link to={routePath}> */}
                    <MDButton
                      className="btn-block center-container-btn btn-warning btn-back rightSpace"
                      color="warning"
                      fullWidth
                      onClick={handleCancel}
                    >
                      Close
                    </MDButton>
                    {/* </Link> */}
                  </Grid>
                  <Grid item xs={12} md={4} spacing={2} lg={1.8}>
                    <MDButton
                      rel="noreferrer"
                      variant="gradient"
                      color="success"
                      fullWidth

                      onClick={handleSaveContact}
                      disabled={SCREEN_RIGHT === "View Only"}
                    >
                      {id ? "Update" : "Save"}
                    </MDButton>
                  </Grid>
                  {values.contactType === "Supplier" && values.contactVerifiedStatus === "Pending" &&
                    <Grid item xs={12} md={4} spacing={2} lg={1.8}>
                      <MDButton
                        rel="noreferrer"
                        variant="gradient"
                        color="info"
                        fullWidth
                        // onClick={handleEmailQuotation}
                        onClick={handleSendEmail}
                      // disabled={SCREEN_RIGHT !== "Full Access" }
                      >  Send Email
                      </MDButton>
                    </Grid>}
                </Grid>

                {/* </Card> */}
              </Grid>
            </Grid>
          </MDBox>

          <DeleteModal
            open={deleteDialogeClick}
            handleDelete={() => handleDeleteDialogeClick(false)}
            handleCancel={() => deleteDialogeClick(false)}
            // closeModalClick={handleCancel("closeModalClick")}
            heading={"Would you like to delete selected records?"}
          />
          <ShowProfile
            open={showImageFlag}
            fileName={file}
            closeModalClick={() => { setShowImageFlag(false) }}
          />

          <Modal
            open={openCropImageModal}
            onClose={() => { handleCropCancel() }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            style={style}
          >
            <Grid className="crop-image-wrapper" id="modal-modal-title" >
              <Grid container spacing={2} style={{ maxHeight: '400px', overflowY: 'auto' }}>
                <Grid style={cropContainer}>
                  <Cropper
                    image={file}
                    crop={crop}
                    zoom={zoom}
                    aspect={dynamicAspect}
                    onCropChange={setCrop}
                    onCropComplete={onCropComplete}
                    onZoomChange={setZoom}
                  />
                </Grid>
                <Grid container spacing={2} className="crop-control" >
                  <Grid item  >
                    <Typography type="label" style={{ color: "white", fontSize: "12px" }}>
                      Aspect Ratio
                    </Typography>{" "}
                    <div style={{ display: "flex", justifyContent: 'center', }}>
                      <select onChange={e => { return setDynamicAspect(parseFloat(e.target.value)); }}  >
                        <option>1/1</option>
                        <option value={'1.23'}>1.23/1</option>
                        <option value={'1.33'}>1.33/1</option>
                        <option value={'1.43'}>1.43/1</option>
                        <option value={'1.625'}>1.66/1</option>
                        <option value={'4.136/2'}>4/2</option>
                        <option value={'1.7'}>16/9</option>
                      </select>
                    </div>
                  </Grid>
                  <Grid item >
                    <Typography type="label" style={{ color: "white", textAlign: "center", fontSize: "12px" }}>
                      Zoom
                    </Typography>&nbsp;
                    <input
                      type="range"
                      value={zoom}
                      min={1}
                      max={11}
                      step={0.1}
                      aria-labelledby="Zoom"
                      onChange={(e) => {
                        setZoom(e.target.value)
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <Button className="modalButton cropimgbtn" onClick={saveCropedImage}>
                      Crop
                    </Button>
                  </Grid>
                  <Grid item style={{ cursor: "pointer", marginRight: "14px", }}>
                    <Button className="modalButton crop-closebtn" onClick={handleCropCancel}>
                      Close
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Modal>

        </Card>
      </div>
      {openPop && (
        <RouteModal
          open={openPop}
          handleRoute={handleRoute}
          // handleCancel={() => handleRouteCancel("handleRouteCancel")}
          closeModalClick={() => handleRouteCancel("closeModalClick")}
          heading={"Email is Sent to Supplier For Verification"}
        />
      )}

      {open && <EmailTemplateModal
        open={open}
        handleClose={handleClose}
        templatesData={templateValues}
        onSend={handleSend}
      />}
    </DashboardLayout>
  );
}

export default AddContact;
